import { useEffect } from 'react';
import { useCms } from '../context/CmsContext';

const setMeta = (name, content, prop = false) => {
  if (!content) return;
  const attr = prop ? 'property' : 'name';
  let el = document.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};

const useSeo = (pageKey) => {
  const seo = useCms('seo', {});
  const page = seo[pageKey] || {};

  useEffect(() => {
    if (page.title) document.title = page.title;
    setMeta('description', page.description);
    setMeta('keywords', page.keywords);
    setMeta('og:title', page.og_title || page.title, true);
    setMeta('og:description', page.og_description || page.description, true);
    setMeta('og:image', page.og_image, true);
    setMeta('og:type', 'website', true);
  }, [page.title, page.description, page.keywords, page.og_title, page.og_description, page.og_image]);
};

export default useSeo;
